import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  APARTMENT_LOCATOR_LEADS_SORT_BY_MOVE_DATE,
  APARTMENT_LOCATOR_LEADS_SORT_BY_LEASE_START_DATE,
  createLeadTableSections,
  getLeadDataTableSettingsFromProps,
} from 'common/apartmentLocatorHelpers';

import {
  LEAD_STATUS_LEASE_SIGNED,
} from 'common/leadConstants';

import SrAgentLeadsSection from 'client/components/SrAgentLeadsSection';

import { dataTable } from 'client/helpers/dataTables';

@dataTable(getLeadDataTableSettingsFromProps)
class SrAgentLeadsSectionPastMonths extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    leadStatus: PropTypes.string.isRequired,
    sectionProps: PropTypes.object.isRequired,
    dataTableIsFullyLoaded: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
    leadsRemovedFromStep: PropTypes.array.isRequired,
  }

  render() {
    const { items, leadStatus, leadsRemovedFromStep, sectionProps } = this.props;
    const sections = createLeadTableSections({
      items,
      leadStatus,
      leadsRemovedFromStep,
      sortCriteria: leadStatus === LEAD_STATUS_LEASE_SIGNED
        ? APARTMENT_LOCATOR_LEADS_SORT_BY_LEASE_START_DATE
        : APARTMENT_LOCATOR_LEADS_SORT_BY_MOVE_DATE,
    });

    return (
      <div>
        {sections.map(({ id, title, items }) => (
          <SrAgentLeadsSection key={id} title={title} items={items} {...sectionProps} />
        ))}
      </div>
    );
  }
}

export default SrAgentLeadsSectionPastMonths;
